import { useState } from 'react';

import { InputWithLabel } from '@/components/shared/InputWithLabel';
import { Button } from '@/components/shared/Button';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { ISolicitacao } from '@/@types/Protocolo/Solicitacoes';
import { useToast } from '@/components/ui/use-toast';
import { api } from '@/services/api';
import { Loading } from '@/components/shared/Loading';

import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { ToastAction } from '@radix-ui/react-toast';


/**
 * Componente para exibir uma lista de solicitações com base em critérios de pesquisa.
 * @returns Componente de lista de solicitações.
 */

const ListaSolicitacoes = () => {
    const [documento, setDocumento] = useState<number>(0);
    const [numProtocolo, setNumProtocolo] = useState<number>(0);
    const [solicitacoesData, setSolicitacoesData] = useState<ISolicitacao[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { toast } = useToast(); // Hook useToast para exibir mensagens de toast


    const getSolicitacoes = async () => {
        // busca as solicitações por número do documento OU número do protocolo
        setIsLoading(true);
        const url = `/protocolo/solicitacoes/solicitante/${documento || 0}/${numProtocolo || 0}`;

        await api.get(url)
            .then(response => {
                setSolicitacoesData(response.data);

                if (response.data.length == 0) {
                    toast({
                        variant: 'default',
                        title: 'Nenhuma solicitação encontrada!',
                        action: <ToastAction altText="close">  <i className='fa fa-times text-gray-500 hover:text-gray-700 '></i>  </ToastAction>
                    });
                }

                setIsLoading(false);

            })
            .catch(err => {
                console.log(err);
                toast({
                    variant: 'destructive',
                    title: 'Erro ao Procurar Solicitação',
                    description: 'Ocorreu um erro ao procurar sua solicitação. Tente novamente mais tarde!',
                    action: <ToastAction altText="close">  <i className='fa fa-times text-white '></i>  </ToastAction>
                });
                setIsLoading(false);

            })
    }


    return (
        <>
            <Card className='mt-[32px]'>
                <CardHeader className='bg-grayCard border-b-gray-100 border-b-2 mb-3 items-center'>
                    <div className='md:flex gap-3 justify-center w-full items-center'>

                        <InputWithLabel
                            label='Documento'
                            value={documento}
                            onChange={({ target }) => setDocumento(parseInt(target.value))}
                            type='number'
                        />
                        <InputWithLabel
                            label='Número do Protocolo'
                            value={numProtocolo}
                            onChange={({ target }) => setNumProtocolo(parseInt(target.value))}
                            type='number'

                        />
                    </div>

                    <Button onClick={getSolicitacoes} variant='primary' className='flex gap-3 w-[110px] self-end'>
                        <i className='fas fa-search-plus'></i>
                        Procurar
                    </Button>
                </CardHeader>

                <CardContent>

                    {isLoading ? (
                        <Loading color='primary' />
                    ) : (
                        <Table className='mt-[16px] font-normal'>
                            <TableHeader>
                                <TableRow>
                                    <TableHead>
                                        <span> <i className='fas fa-list-ol'></i> Protocolo</span>
                                        <br />
                                        <span> <i className='far fa-calendar-alt'></i> Data</span>
                                    </TableHead>

                                    <TableHead>
                                        <span> <i className='far fa-file-alt'></i> Serviço</span>
                                    </TableHead>

                                    <TableHead>
                                        <span> <i className='fas fa-paperclip'></i> Anexo</span>
                                    </TableHead>

                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {solicitacoesData.map(solicitacao => {
                                    return (
                                        <TableRow key={solicitacao._id}>
                                            <TableCell>
                                                {solicitacao.protocolo_numero} <br />
                                                {format(solicitacao.protocolo_data, 'dd/MM/yyyy')} - {solicitacao.protocolo_hora}
                                            </TableCell>

                                            <TableCell>{solicitacao.protocolo_servico}</TableCell>

                                            <TableCell className='break-words'>
                                                {solicitacao.protocolo_anexo ?
                                                    <a className='block w-[200px] break-words' target='_blank' href={solicitacao.protocolo_anexo}>
                                                        {solicitacao.protocolo_anexo}
                                                    </a>
                                                    : 'Nenhum arquivo anexado'}
                                            </TableCell>

                                            <TableCell>
                                                <Link target='_blank' to={`/extranet/academico/protocolo/solicitacoes/${solicitacao._id}`}>
                                                    <Button variant='primary' className='flex-col items-center p-4'>
                                                        <i className='fas fa-search'></i>
                                                        Pesquisar
                                                    </Button>
                                                </Link>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    )}

                </CardContent>
            </Card>
        </>
    );
}

export { ListaSolicitacoes };